import { useTranslations } from '@vocab/react';
import React, { forwardRef, type Ref } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { SECTION_BRAND_SELECTION } from 'src/app/shared/constants/pageSectionName';
import { BrandingEditView as Edit } from 'src/app/v1/views/pages/Edit/components/BrandingEditView';
import { BrandingReadOnlyView as Read } from 'src/app/v1/views/pages/Edit/components/BrandingReadOnlyView';
import { EditablePageSection } from 'src/app/v1/views/sections/EditablePageSection';
import type { AppState } from 'src/types/appState';
import type { SectionProps, SectionRef } from 'src/types/sections';

import translations from './.vocab';

export const BrandingSection = forwardRef(
  (_props: SectionProps, ref: Ref<SectionRef>) => {
    const { isPrivateAdvertiser } = useSelector(
      (state: AppState) => ({
        isPrivateAdvertiser:
          state.session.hirerAccount?.isPrivateAdvertiser ?? undefined,
      }),
      shallowEqual,
    );

    const { t } = useTranslations(translations);
    return (
      <EditablePageSection
        title={t('branding-section-title')}
        name={SECTION_BRAND_SELECTION}
        ref={ref}
        fields={[]}
        read={<Read />}
        edit={<Edit />}
        disableEdit={isPrivateAdvertiser}
      />
    );
  },
);
